export const RETRIEVE_COUNTRIES = "RETRIEVE_COUNTRIES";
export const SET_COUNTRIES_INFO = "SET_COUNTRIES_INFO";
